<div class="component-container">
<div class="verification-container">
    <div class="logo">
        <div class="logo-text">SECURE<span>AUTH</span></div>
    </div>
    
    <h1>Verification</h1>
    <p class="description">We're verifying your request. This will only take a moment.</p>
    
    <!-- Loading State -->
    <div class="status-loading-container" id="loadingState" [style.display]="isLoading ? 'block' : 'none'">
        <div class="status-loading"></div>
        <p class="status-message">Verifying...</p>
        <p class="status-details">Please wait while we verify your request.</p>
    </div>
    
    <!-- Success State -->
    <div class="status-success" id="successState" [style.display]="isTokenValid ? 'block' : 'none'">
        <div class="status-icon">✓</div>
        <p class="status-message">Verification Successful</p>
        <p class="status-details">Your request has been verified successfully.</p>
        
        <div class="token-info">
            <p><span>Verification:</span> {{ tokenResponse.type }}</p>
    
        </div>
        
        <div>
            <a [routerLink]="['/login']" class="btn btn-primary">Continue to Login</a>
        </div>
    </div>
    
    <!-- Error State -->
    <div class="status-error" id="errorState" [style.display]="!isTokenValid && !isLoading? 'block' : 'none'">
        <div class="status-icon">✕</div>
        <p class="status-message">Verification Failed</p>
        <p class="status-details">The token is invalid or has expired.</p>
        
        <div>
            <a [routerLink]="['/login']" class="btn btn-secondary">Back to Login</a>
        </div>
    </div>
    
    <footer>
        <p>Having trouble? <a href="#">Contact Support</a></p>
    </footer>
</div>
</div>